import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaEmisionFormGroup = ({ iError, iTouched, fIsSubmitting, handleChange, values, setValues }) => {
  const onInputChange = React.useCallback(
    e => {
      handleChange(e)
      const nuevaFecha = e.target.value
      values.fechaEmision = nuevaFecha
      values.fechaEntrega = nuevaFecha
      setValues(values)
    },
    [handleChange, values, setValues]
  )

  return (
    <Form.Group>
      <Form.Label text='F. EMISION' htmlFor='date-fechaEmision' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaEmision'>
          {({ field }) => (
            <Form.InputDate {...field} id='date-fechaEmision' onChange={onInputChange} disabled={fIsSubmitting} isInvalid={iTouched && iError} />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaEmisionFormGroup)
